import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicUnlink({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.52 10.793a.75.75 0 01.101 1.493l-.102.007h-2a.25.25 0 00-.243.193l-.007.057v2a.75.75 0 01-1.493.102l-.007-.102v-2a1.75 1.75 0 011.607-1.744l.143-.006h2zM4.98 6.769a.75.75 0 01.067.984l-.067.076-1.414 1.415a2.25 2.25 0 003.069 3.287l.112-.105 1.415-1.415a.75.75 0 011.127.984l-.067.077-1.414 1.414a3.75 3.75 0 01-5.44-5.158l.137-.145 1.414-1.414a.75.75 0 011.06 0zm4.95-.707a.75.75 0 01.067.984l-.068.076-2.828 2.829a.75.75 0 01-1.128-.984l.067-.077L8.87 6.062a.75.75 0 011.06 0zm3.535-3.536a3.75 3.75 0 01.137 5.159l-.137.144-1.414 1.415a.75.75 0 01-1.128-.984l.067-.077 1.414-1.414a2.25 2.25 0 00-3.069-3.287l-.113.105L7.808 5a.75.75 0 01-1.128-.984l.067-.077 1.415-1.414a3.75 3.75 0 015.303 0zM4.478.752a.75.75 0 01.744.648l.006.102v2a1.75 1.75 0 01-1.606 1.744l-.144.006h-2a.75.75 0 01-.101-1.493l.101-.007h2a.25.25 0 00.244-.193l.006-.057v-2a.75.75 0 01.75-.75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicUnlink.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicUnlink.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicUnlink svgRef={ref} {...props} />);
export default ForwardRef;
